module.exports = __webpack_public_path__ + "img/forbes.4d510524.png";